import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import Button, { BUTTON_HEIGHT_32 } from '../../../Button'
import Text from '../../../Text'
import { Widget } from '../../../Widget'
import {
  useApplicantAttentionAction,
  useApplicantProfileContext,
} from '../RentalPortalApplicantProfile.hooks'
import { getApplicantDecisionAwaitingText } from '../RentalPortalApplicantProfileTabOverview'

import {
  QA_NAME_APPLICANT_PROFILE_WIDGET_ATTENTION,
  QA_NAME_APPLICANT_PROFILE_WIDGET_ATTENTION_ACTION,
} from './RentalPortalApplicantProfileWidgetAttention.constants'
import { getApplicantAttentionWidgetActionProps } from './RentalPortalApplicantProfileWidgetAttention.utils'

import * as styles from './RentalPortalApplicantProfileWidgetAttention.module.css'

function RentalPortalApplicantProfileWidgetAttention() {
  const { t } = useTranslation()

  const { applicantData, isInitiated, isPreview } = useApplicantProfileContext()

  const {
    handleClickAction,
    isActionDisabled,
    isActionFullPageOnly,
    primaryAction,
    tooltipKey,
  } = useApplicantAttentionAction()

  const awaitingText = getApplicantDecisionAwaitingText({ applicantData, t })

  const actionProps = getApplicantAttentionWidgetActionProps({
    isActionDisabled,
    isActionFullPageOnly,
    isPreview,
    primaryAction,
    onClickAction: handleClickAction,
  })

  return !isInitiated || actionProps || awaitingText ? (
    <Widget
      contentContainerProps={{ className: styles.content }}
      headerProps={{ contentProps: { actionsProps: { EditButton: null } } }}
      isSkeleton={!isInitiated}
      qaName={QA_NAME_APPLICANT_PROFILE_WIDGET_ATTENTION}
      title={t('RentalPortal.OverviewNeedsAttentionTitleKey')}
    >
      {awaitingText ? (
        <Text isSecondary className={styles.text}>
          {awaitingText}
        </Text>
      ) : null}
      {actionProps ? (
        <Button.Outlined
          showTextTooltip
          className={styles.action}
          disabled={actionProps.isDisabled || !actionProps.onClick}
          height={BUTTON_HEIGHT_32}
          qaName={QA_NAME_APPLICANT_PROFILE_WIDGET_ATTENTION_ACTION}
          text={t(actionProps.label)}
          tooltip={tooltipKey ? t(tooltipKey) : null}
          tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
          onClick={actionProps.onClick}
        />
      ) : null}
    </Widget>
  ) : null
}

export default RentalPortalApplicantProfileWidgetAttention
